import React from 'react';

import QuestionHOC from './QuestionHOC';

export default function Race({ item, index }) {
  const displayQuestion = () => {
    if (item.hasOwnProperty('onlyAnswer') && item.onlyAnswer === true) {
      return <div className="col">Asian</div>
    } else {
      return <>
        <div className="col-8">Race</div>
        <div className="col-4">Asian</div>
      </>
    }
  }

  return <QuestionHOC item={item} index={index}>
    <div className="row">
      {displayQuestion()}
    </div>
  </QuestionHOC>
}